<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 to-black text-white p-4">
    <div class="w-full max-w-3xl bg-gray-800 bg-opacity-95 p-10 rounded-2xl shadow-2xl border border-gray-800 shadow-xl bg-gradient-to-br from-gray-800 to-gray-900 backdrop-blur-lg flex items-center justify-between">
      <div class="flex-1 text-center pr-8">
        <img src="@/assets/logo.svg" alt="Vultric Logo" class="w-40 mx-auto mb-4" />
        <h2 class="text-4xl font-extrabold text-blue-400">Visit the Cloud</h2>
        <p class="text-gray-300 mt-2">Powerful cloud solutions at your fingertips.</p>
      </div>

      <div class="flex-1">
        <form @submit.prevent="handleLogin" class="space-y-6">
          <div v-if="!requires2FA">
            <label class="block text-gray-400 mb-2 text-sm font-medium" for="email">Email</label>
            <input id="email" v-model="email" type="email"
              class="w-full p-3 rounded-lg bg-gray-700 bg-opacity-80 border border-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300 placeholder-gray-400 text-white"
              placeholder="Enter your email" required />
          </div>

          <div v-if="!requires2FA">
            <label class="block text-gray-400 mb-2 text-sm font-medium" for="password">Password</label>
            <input id="password" v-model="password" type="password"
              class="w-full p-3 rounded-lg bg-gray-700 bg-opacity-80 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300 placeholder-gray-400 text-white"
              placeholder="Enter your password" required />
          </div>

          <div v-if="requires2FA">
            <label class="block text-gray-400 mb-2 text-sm font-medium" for="otp">Enter 2FA Code</label>
            <input id="otp" v-model="otp" type="text"
              class="w-full p-3 rounded-lg bg-gray-700 bg-opacity-80 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300 placeholder-gray-400 text-white"
              placeholder="6-digit code" required />
          </div>

          <button type="submit"
            class="w-full py-3 bg-blue-600 rounded-lg text-lg font-semibold hover:bg-blue-700 transition duration-300 transform hover:scale-105 focus:ring-2 focus:ring-blue-400 focus:outline-none shadow-md">
            {{ requires2FA ? "Verify 2FA" : "Login" }}
          </button>
        </form>

        <p class="text-center text-gray-400 mt-6" v-if="!requires2FA">
          Don't have an account? 
          <a href="/signup" class="text-blue-400 hover:underline">Sign up</a>
        </p>
        
        <p class="text-center text-gray-400 mt-4" v-if="!requires2FA">
          Forgot your password? 
          <router-link to="/forgot-password" class="text-blue-400 hover:underline">
            Reset it here
          </router-link>
        </p>
      </div>
    </div>
  </div>
    <!-- Toast Notifications -->
    <ToastManager ref="toastManager" />
</template>

<script>
import axios from 'axios';
import ToastManager from '@/components/ToastManager.vue'
export default {
  name: "LoginPage",
  components: {
    ToastManager
  },
  data() {
    return {
      email: "",
      password: "",
      otp: "",
      requires2FA: false,
      userId: null
    };
  },
  methods: {
    async handleLogin() {
      try {
        if (!this.requires2FA) {
          const response = await axios.post("https://api.syniac.com:3000/api/auth/login", { email: this.email, password: this.password }, { withCredentials: true });

          if (response.data.requires2FA) {
            this.requires2FA = true;
            this.userId = response.data.userId;
          } else {
            this.$router.push('/dashboard');
          }
        } else {
          await axios.post("https://api.syniac.com:3000/api/auth/2fa/complete", { userId: this.userId, otp: this.otp }, { withCredentials: true });
          this.$router.push('/dashboard');
        }
      } catch (error) {
        this.$refs.toastManager.addToast('Login failed!', 'error');
      }
    }
  }
};
</script>
